// useDraftState.js - Draft management state
import { useState } from 'react';

export const useDraftState = () => {
  // Draft system state
  const [currentDraftId, setCurrentDraftId] = useState(null);
  const [savingDraft, setSavingDraft] = useState(false);
  const [autoSaveDraftId, setAutoSaveDraftId] = useState(null);

  // Planning data for tour generation
  const [planningData, setPlanningData] = useState({
    timeOfDay: 'morning',
    duration: '2-3 hours',
    interests: [],
    travelWith: 'alone',
    mobility: 'walking',
    pace: 'moderate',
    budget: 'moderate'
  });

  const [isTourGeneratingLocal, setIsTourGeneratingLocal] = useState(false);

  // Draft utility functions
  const resetDraftState = () => {
    setCurrentDraftId(null);
    setSavingDraft(false);
    setAutoSaveDraftId(null);
    setIsTourGeneratingLocal(false);
  };

  const updatePlanningData = (updates) => {
    setPlanningData(prev => ({
      ...prev,
      ...updates
    }));
  };

  const resetPlanningData = () => {
    setPlanningData({
      timeOfDay: 'morning',
      duration: '2-3 hours',
      interests: [],
      travelWith: 'alone',
      mobility: 'walking',
      pace: 'moderate',
      budget: 'moderate'
    });
  };

  return {
    // Draft state
    currentDraftId,
    setCurrentDraftId,
    savingDraft,
    setSavingDraft,
    autoSaveDraftId,
    setAutoSaveDraftId,

    // Planning state
    planningData,
    setPlanningData,
    isTourGeneratingLocal,
    setIsTourGeneratingLocal,

    // Utility functions
    resetDraftState,
    updatePlanningData,
    resetPlanningData
  };
};